module.exports = __webpack_public_path__ + "static/android_experiments_logo_5.74322aa1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/awards/android_experiments_logo_5.jpg
// module id = 479
// module chunks = 35783957827783